import React from 'react';
import * as Styled from './ACurrency.styles';
import type { ACurrencyProps } from './ACurrency.types';
import { ACurrencySize } from './ACurrency.types';

const COMPONENT_NAME = 'a-web-ui-kit-ACurrency';
const TEST_ID = 'web-ui-kit-ACurrency';

export const ACurrency: React.FC<ACurrencyProps> = ({ text, ...rest }) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      size={ACurrencySize.ExtraSmall}
      {...rest}
    >
      {text}
    </Styled.Wrapper>
  );
};
